import { HEIGHT, WIDTH } from '~/lib/stage'

// The picture params every source's bag holds beside its own (`sourceParams`): a mirror for any source, zoom and pan for a picture with its own frame (camera, screen, file).
export const MIRROR_PARAM = { mirror: { type: 'boolean', initial: false, label: 'Mirror' } }

export const FRAME_PARAMS = {
	zoom: { type: 'number', initial: 100, minimum: 100, maximum: 999, step: 1, natural_step: 10, label: 'Zoom' },
	panX: { type: 'number', initial: 0, minimum: -WIDTH, maximum: WIDTH, step: 1, label: 'Pan X' },
	panY: { type: 'number', initial: 0, minimum: -HEIGHT, maximum: HEIGHT, step: 1, label: 'Pan Y' },
}
